export default __webpack_public_path__ + "static/media/Graph_SMP-LowToMedium.5872986a.svg";